/** Whether to render the scanned attendance block on RSVP demographics. */
export function shouldShowScannedAttendance(
  totalScannedAttendees: number | undefined,
  alwaysShowAttendance: boolean
): boolean {
  if (alwaysShowAttendance) return true;
  return (totalScannedAttendees ?? 0) > 0;
}
